<script setup lang="ts">
import { reactive, ref } from "vue";
import { v4 } from "uuid";

const user = reactive({
  firstname: "Иван",
  connectId: v4(),
  companyId: v4(),
  secondname: "Иванов",
  avatar:
    "https://repository-images.githubusercontent.com/130118224/a2c75780-e0a9-11eb-8494-3581a0b1c93b",
  companyName: "Коннект",
  tarif: "PAY",
});
const roomLink = ref("");
const res = ref("");
const methodurl = `/api/auth/create`;
const go = async () => {
  const resp = await fetch(methodurl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(user),
  })
    .then((data) => data.json())
    .then((json) => {
      return json.token;
    });
  res.value = resp;
    window.open(
      `/?token=${res.value}`,
      "_blank",
    );
};

const goRoom = async () => {
  if (!roomLink.value) return false;
  const resp = await fetch(methodurl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(user),
  })
    .then((data) => data.json())
    .then((json) => {
    return json.token;
    });
  res.value = resp;
  if (import.meta.env.DEV) {
    window.open(`${roomLink.value}?token=${res.value}`, "_blank");
  } else {
    window.open(`${roomLink.value}?token=${res.value}`, "_blank");
  }
};
</script>

<template>
  <div class="page">
      <div class="card">
    PS: теперь можно менять настройки
    <input v-model="user.firstname" />
    <input v-model="user.secondname" />
    <input v-model="user.companyName" />
    <label>ConnectId</label>
    <input v-model="user.connectId" />
    <label>CompanyId</label>
    <input v-model="user.companyId" />
    <input v-model="user.avatar" />
    <select v-model="user.tarif">
      <option value="PAY">Платный</option>
      <option value="FREE">Бесплатный</option>
    </select>
    <button type="button" @click="go">К созданию</button>
    или введите ссылку для подключения <br />
    для входа с введенными выше параметрами
    <input v-model="roomLink" />
    <button type="button" @click="goRoom">Подключится</button>
  </div>
  </div>
</template>

<style scoped>
.read-the-docs {
  color: #888;
}

.page {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  height: 100dvh;
}

.card {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
</style>
